module.exports = __webpack_public_path__ + "static/media/Student-dashboard-myclasses-All-1.7cdd08ce.png";